import { Label } from '@cian/ui-kit/label';
import React, { memo } from 'react';

export const AuctionBadgeComponent: React.FC = () => {
  return (
    <Label background="accent-ghost-secondary" color="text-primary-default" data-mark="AuctionBadge">
      Аукцион
    </Label>
  );
};

AuctionBadgeComponent.displayName = 'AuctionBadge';

export const AuctionBadge = memo(AuctionBadgeComponent);
